import * as React from 'react';

import {RouteComponentProps} from 'react-router';
import Page from './Page';
import { Header, Breadcrumb } from 'semantic-ui-react';
import {Link} from 'react-router-dom';

interface Props {
	id?: string;
}

interface State {
}

export default class ContactPage extends Page<RouteComponentProps<Props>, State> {

	protected isLoading (): any {
		return false;
	}

	protected renderTitle (): string {
		return 'Brain Brooder - Contact';
	}

	protected renderDescription (): string {
		return 'Improving education through personalization, rooting out weaknesses, and a focus on the long term.';
	}

	protected renderContent () {
		const sections = [{ key: 'Home', content: <Link to={'/'}>Home</Link> }, { key: 'Contact', content: 'Contact', active: true }];

		return (
			<div className={'lesson'}>
				<Breadcrumb icon='right angle' sections={sections} />

				<Header dividing as='h1' inverted>Contact</Header>

				<div style={{width: '100%', textAlign: 'center', marginTop: '160px'}}><img style={{width: '307px'}} src='/images/contact.png' /></div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/ContactPage.tsx